import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

const TIME_RANGE_SEPARATOR = "–";

// Backend sends "HH:mm:ss"; "HH:mm" is tolerated. Output is "H:mm".
const formatTime = (time: string | null | undefined): string => {
	if (!time) return "";
	const [hours, minutes] = time.split(":");
	if (hours === undefined || minutes === undefined) return "";
	return `${Number(hours)}:${minutes.slice(0, 2)}`;
};

export const formatActivityDateAndTimes = (
	date: string | null | undefined,
	timeFrom: string | null | undefined,
	timeTo: string | null | undefined,
): string => {
	if (!date) return "";
	const dateStr = dateFormatter(date, DateFormat.DisplaySpaced);
	const from = formatTime(timeFrom);
	const to = formatTime(timeTo);
	if (from && to) return `${dateStr} ${from}${TIME_RANGE_SEPARATOR}${to}`;
	if (from) return `${dateStr} ${from}`;
	return dateStr;
};
